import { ImisResponseItems, PanelDefinitionItem } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

/**
 * Static helpers for reading iMIS panel definitions via the REST API.
 */
export class PanelsUtility {
    /**
     * Retrieves all panel definitions from iMIS.
     * @returns All panel definition items from the /api/paneldefinition endpoint.
     */
    public static getAllPanelDefinitions(): Promise<ImisResponseItems<PanelDefinitionItem>> {
        return RestUtility.restApiGetDataAll<PanelDefinitionItem>("/api/paneldefinition");
    }

    /**
     * Retrieves a single panel definition by its ID, returning null instead of throwing if the request fails.
     * @param panelId The ID of the panel definition to retrieve.
     * @param rawResponse Optional flag to request the raw (unparsed) REST response instead of the parsed data.
     * @returns The panel definition item, or null if it could not be retrieved.
     */
    public static async getPanelDefinition(panelId: string, rawResponse?: boolean): Promise<PanelDefinitionItem> {
        let panelDefinitionItem: PanelDefinitionItem;

        try {
            panelDefinitionItem = await RestUtility.restApiGetData<PanelDefinitionItem>(`/api/paneldefinition/${panelId}`, null, rawResponse);
        } catch (error) {
            panelDefinitionItem = null;
        }

        return panelDefinitionItem;
    }

}